import { create } from "zustand";

interface ModalState {
  appOffline: boolean;
  setAppOffline: (bool: boolean) => void;
}

export const useAppStore = create<ModalState>((set) => ({
  appOffline: false,
  setAppOffline: (bool) => set({ appOffline: bool }),
}));
